module.exports = "<p>{{Question.prompt}}</p>\n<input type=\"textbox\" class=\"form-control\" (ngModelChange)=\"handleChange($event)\" [ngModel]=\"Question.answer\" />"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessments/question-textbox/question-textbox.component.html
// module id = ./src/app/assessments/question-textbox/question-textbox.component.html
// module chunks = main